import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirInvitationTemplateCreate() {
  return {
    categories: [],
    layouts: [],
    cloneSources: [],
    capabilities: {},
    config: {},
    saving: false,
    form: {
      name: '',
      category_id: '',
      description: '',
      view_key: 'classic',
      is_premium: false,
      price: 0,
      is_featured: false,
      clone_from_id: '',
    },

    init() {
      try {
        this.config = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.categories = this.config.categories || [];
        this.layouts = this.config.layouts || [];
        this.cloneSources = this.config.cloneSources || [];
        if (this.categories.length) {
          this.form.category_id = this.categories[0].id;
        }
      } catch (e) {
        console.error(e);
      }
      this.loadCapabilities();
    },

    async loadCapabilities() {
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/invitation-templates');
        this.capabilities = data.data?.capabilities || {};
      } catch (_) {
        this.capabilities = {};
      }
    },

    async submit() {
      if (!this.form.name?.trim()) {
        window.toast?.('Nama template wajib diisi.', 'error');
        return;
      }

      this.saving = true;
      try {
        let row;

        if (this.form.clone_from_id) {
          const { data } = await axios.post(
            `/api/v1/kasir/engagement/invitation-templates/${this.form.clone_from_id}/clone`,
            { name: this.form.name.trim() },
          );
          row = data.data;
          await axios.put(`/api/v1/kasir/engagement/invitation-templates/${row.id}`, {
            category_id: this.form.category_id,
            description: this.form.description,
            view_key: this.form.view_key,
            is_premium: this.form.is_premium,
            price: this.form.price,
            is_featured: this.form.is_featured,
          });
        } else {
          const body = { ...this.form };
          delete body.clone_from_id;
          const { data } = await axios.post('/api/v1/kasir/engagement/invitation-templates', body);
          row = data.data;
        }

        window.toast?.('Template dibuat. Membuka Theme Builder...', 'success');
        const designUrl = row.design_url
          || (this.config.designRouteTemplate || '').replace('__ID__', row.id);
        window.location.href = designUrl;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal membuat template.', 'error');
      } finally {
        this.saving = false;
      }
    },
  };
}

Alpine.data('kasirInvitationTemplateCreate', createKasirInvitationTemplateCreate);
